import { Injectable } from "@angular/core";
import { KekaAccessDto, KekaManagerApprovalServiceProxy } from "@shared/service-proxies/service-proxies";
import { Observable, of } from "rxjs";
import { catchError, shareReplay } from "rxjs/operators";

/**
 * What the current user may do with Keka: approvers and super admins can see the Keka pages,
 * super admins can decide every request. Loaded once and shared; a failed call means no access.
 */
@Injectable({ providedIn: "root" })
export class KekaAccessService {
    private access$: Observable<KekaAccessDto> | undefined;

    constructor(private _approvalService: KekaManagerApprovalServiceProxy) {}

    get(): Observable<KekaAccessDto> {
        if (!this.access$) {
            this.access$ = this._approvalService.getMyAccess().pipe(
                catchError(() => of(new KekaAccessDto({ isApprover: false, isSuperAdmin: false, canView: false }))),
                shareReplay(1),
            );
        }
        return this.access$;
    }
}
